<template>
    <div>
        <v-autocomplete
            v-model="entity"
            :items="entities"
            :item-value="itemValue"
            item-text="name"
            :label="label"
            outlined
            dense
            :multiple="multiple"
            :chips="multiple"
            :deletable-chips="!readonly"
            :color="inputColor"
            :background-color="inputBackgroundColor"
            :readonly="readonly"
            :loading="loading"
            :clearable="!(readonly || notClearable)"
            @input="input"
            :rules="rules"
            hide-details="auto"
        ></v-autocomplete>

        <input type="hidden">
    </div>
</template>

<script>
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData.js";
import axios from "axios";

export default {
    name: "WServerAutocomplete",
    props: {
        value: [Number, Array],
        api: String,
        itemValue: {
            type: String,
            default: "id"
        },
        readonly: Boolean,
        notClearable: Boolean,
        multiple: Boolean,
        label: String,
        rules: Array,
    },
    setup(props, {emit}) {
        const {loading, inputColor, inputBackgroundColor} = useSharedData();

        const entity = ref(null);
        const entities = ref([]);

        function findAll() {
            loading.value = true;
            axios.get(`/${props.api}`).then(response => {
                entities.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function input(value) {
            emit('input', value)
        }

        watch(() => props.value, () => {
            if (props.value)
                entity.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            loading,
            inputColor,
            inputBackgroundColor,
            entity,
            entities,
            input,
        }
    }
}
</script>

<style scoped>

</style>